
import youtubeClient from './youtube/youtubeClient';
import apiService from './youtube/apiService';
import mockYoutubeData from './youtube/mockYoutubeData';
import { Content } from '@/types/content';

// Use Contentful data instead of making actual API calls or using mock data
const USE_CONTENTFUL = true;

const getPopularVideos = async (): Promise<Content[]> => {
  if (USE_CONTENTFUL) {
    // Return empty array as we're not using mock data anymore
    return [];
  }
  return apiService.getPopularVideos();
};

const searchVideos = async (query: string): Promise<Content[]> => {
  if (USE_CONTENTFUL) {
    // Return empty array as we're using Contentful search in the Search page
    return [];
  }
  return youtubeClient.searchYouTube(query);
};

const getChannelVideos = async (channelId: string): Promise<Content[]> => {
  if (USE_CONTENTFUL) {
    // Return empty array as we're using Contentful data
    return [];
  }
  return youtubeClient.fetchChannelVideos(channelId);
};

const getPlaylists = () => {
  if (USE_CONTENTFUL) {
    // Return empty array as we're using Contentful data
    return [];
  }
  return [];
};

const getFeaturedVideo = (): Content | null => {
  if (USE_CONTENTFUL) {
    // Return null as we're using Contentful data
    return null;
  }
  return null;
};

export default {
  getPopularVideos,
  searchVideos,
  getChannelVideos,
  getPlaylists,
  getFeaturedVideo
};
